<div class="d-flex h-100 flex-column justify-content-center align-items-center">
  <div class="mb-3">
    <img src="/images/addcar-logo-red.png" alt="addCar" />
  </div>
  <form [formGroup]="form" (ngSubmit)="login()">
    <div class="alert alert-light">Welcome to addCar Reservation System Module</div>
    <div class="mb-2">
      <div class="input-group">
        <div class="input-group-text"><i class="fa fa-user fa-fw"></i></div>
        <input type="text" class="form-control validated" placeholder="Username" formControlName="userName" />
      </div>
    </div>
    <div class="mb-3">
      <div class="input-group">
        <div class="input-group-text"><i class="fa fa-lock fa-fw"></i></div>
        <input type="password" class="form-control validated" placeholder="Password" formControlName="password" />
      </div>
    </div>
    <div class="mb-3 d-flex justify-content-center">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="remember" formControlName="remember" />
        <label class="form-check-label" for="remember">Remember me</label>
      </div>
    </div>
    @if (errors) {
      <div class="alert alert-danger">
        @for (error of errors; track $index) {
          <div class="text-center">{{ error }}</div>
        }
      </div>
    }
    <button type="submit" class="btn btn-lg btn-primary w-100" [disabled]="loading">
      <div class="d-flex justify-content-center align-items-center gap-2">
        <div>
          @if (loading) {
            <i class="fa-solid fa-circle-notch fa-spin fa-fw"></i>
          } @else {
            <i class="fa fa-sign-in-alt fa-fw"></i>
          }
        </div>
        <div>Log in</div>
      </div>
    </button>
  </form>
</div>
